import { useLayoutEffect, useRef, useState } from 'react';

import { useHeaderFlyoutStore } from '../../../shared';

export function useSearchFlyout() {
    const inputRef = useRef<HTMLInputElement>(null);
    const [open, setOpen] = useState(false);
    const isFlyoutActive = useHeaderFlyoutStore(state => state.activeFlyout !== null);

    useLayoutEffect(() => {
        if (!isFlyoutActive) return;

        setOpen(false);
        inputRef.current?.blur();
    }, [isFlyoutActive]);

    function onOpenChange(nextOpen: boolean) {
        if (nextOpen && isFlyoutActive) return;
        setOpen(nextOpen);
    }

    function onInputFocus() {
        if (isFlyoutActive) {
            inputRef.current?.blur();
            return false;
        }

        setOpen(true);
        return true;
    }

    function closeSearch() {
        setOpen(false);
        inputRef.current?.blur();
        requestAnimationFrame(() => inputRef.current?.blur());
    }

    return {
        closeSearch,
        inputRef,
        onInputFocus,
        onOpenChange,
        open,
    };
}
